<template>
  <div class="container">
    <h4 class="title is-4">Submissions Overview</h4>
    <div class="field has-addons">
      <div class="control is-expanded">
        <input class="input" v-model="filters.search" @keyup.enter="refreshData()" />
      </div>
      <div class="control">
        <button class="button" @click="refreshData()" @keyup.enter="refreshData()">Search</button>
      </div>
    </div>
    <div class="level">
      <div class="level-left">
        <div class="level-item">
          <div class="select">
            <select v-model="filters.pageSize" @change="refreshData()">
              <option :value="20">20 per page</option>
              <option :value="50">50 per page</option>
              <option :value="100">100 per page</option>
              <option :value="100">250 per page</option>
              <option :value="999999">All results</option>
            </select>
          </div>
        </div>
      </div>
      <div class="level-right">
        <button class="button" @click="sendEmailToPage()">
          Email all submitters on this page
        </button>
        <button class="button" style="marginLeft: 0.5rem;">
          <router-link :to="{ name: 'StaffUploadApplications' }">Bulk Upload Proposals</router-link>
        </button>
      </div>
    </div>
    <loading-box v-if="!submissionDataLoaded"></loading-box>
    <div v-if="submissionDataLoaded">
      <pagination
        :pagination-details="paginationDetails"
        @update="refreshData($event)"
      ></pagination>
      <div v-if="updatingData">
        <div class="columns">
          <div class="column"></div>
          <div class="column is-half has-text-centered" style="margin-top: 150px">
            <i class="fa fa-refresh fa-spin fa-5x"></i>
          </div>
          <div class="column"></div>
        </div>
      </div>
      <table class="table" v-if="!updatingData">
        <thead>
          <tr>
            <th>Organization</th>
            <th class="projName">Project Name</th>
            <th class="evals">Evaluators</th>
            <th class="orgSub">Organization Submitted to</th>
            <th>View Report</th>
            <th>Email Submitter</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="submission in submissions" :key="submission.id">
            <td>
              <router-link
                :to="{
                  name: 'StaffApplicationReviewDetail',
                  params: { applicationId: submission.id },
                }"
                >{{ submission.organization.name }}</router-link>
            </td>
            <td class="projName">
              <router-link
                :to="{
                  name: 'StaffApplicationReviewDetail',
                  params: { applicationId: submission.id },
                }"
                >{{ submission.projectName }}</router-link
              >
            </td>
            <td class="evals">
              <span v-for="evaluator in submission.evaluatorsRef" :key="evaluator.id">
                <router-link
                  :to="{ name: 'EvaluatorDetail', params: { evaluatorId: evaluator.id } }"
                >
                  <span
                    class="tag"
                    :class="{
                      'is-primary': userCompletedAssignment(evaluator, submission),
                      'is-warning': userStartedAssignment(evaluator, submission),
                    }"
                  >
                    {{ evaluator.fullName }}
                  </span>
                </router-link>
              </span>
            </td>
            <td class="orgSub">
              <router-link
                :to="{
                  name: 'StaffApplicationReviewDetail',
                  params: { applicationId: submission.id },
                }"
                >{{ submission.organizationSubmittedTo }}</router-link
              >
            </td>
            <td>
              <button
                class="button is-primary is-outlined"
                @click="toViewReport(submission.id)"
                v-if="submission.reportRef && submission.reportRef.published"
              >
                View Report
              </button>
              <button
                class="button is-primary"
                @click="toGenerateReport(submission.id)"
                v-if="!submission.reportRef || !submission.reportRef.published"
              >
                Prepare Report
              </button>
            </td>
            <td>
              <button class="button" @click="sendEmailToApplication(submission)">
                Send Group Email
              </button>
            </td>

          </tr>
        </tbody>
      </table>
      <BulkEmailSubmittersModal
        v-if="showModal"
        :applications="selectedApplications"
        @close="showModal = !showModal"
        @submit="refreshData()"
      />
    </div>
  </div>
</template>

<script>
import Application from '@/services/applications'
import LoadingBox from '@/components/LoadingBox'
import Pagination from '@/components/Pagination'
import { getPaginationDataFromResponse } from '@/services/pagination'
import BulkEmailSubmittersModal from '@/components/emails/BulkEmailSubmittersModal'

export default {
  components: { LoadingBox, Pagination, BulkEmailSubmittersModal },
  data() {
    return {
      updatingData: false,
      submissionDataLoaded: false,
      showModal: false,
      submissions: [],
      selectedApplications: [],
      paginationDetails: {},
      filters: {
        search: '',
        pageSize: 20,
      },
    }
  },
  created() {
    this.refreshData()
  },
  methods: {
    sendEmailToApplication(app) {
      //console.log("sendEmailToEvaluator");
      this.showModal = false
      console.log("Submitter")
      console.log(app)
      this.selectedApplications = [app]
      this.showModal = true
    },
    sendEmailToPage() {
      this.showModal = false
      this.selectedApplications = [...this.submissions]
      this.showModal = true
    },
    refreshData(page = null) {
      this.showmodal = false
      this.updatingData = true
      let dataFilters = {}
      if (page) {
        dataFilters = { ...this.filters, page: page }
      } else {
        dataFilters = { ...this.filters }
      }
      Application.api.list({ filters: dataFilters }).then(data => {
        this.paginationDetails = getPaginationDataFromResponse(data)
        this.submissions = data.results
        this.submissionDataLoaded = true
        this.updatingData = false
      })
    },
    userCompletedAssignment(userRef, submission) {
      return submission.evaluationsRef.find(
        evaluation => evaluation.evaluator === userRef.id && evaluation.isCompleted,
      )
    },
    userStartedAssignment(userRef, submission) {
      return submission.evaluationsRef.find(
        evaluation =>
          evaluation.evaluator === userRef.id && !evaluation.isCompleted && !evaluation.isEmpty,
      )
    },
    getEvaluatorStatusClass(evaluator) {
      if (evaluator) {
        if (!evaluator.pendingAsEvaluator) {
          return { class: { 'is-success': true }, label: 'APPROVED' }
        } else {
          return { class: {}, label: 'PENDING' }
        }
      }
    },
    toGenerateReport(applicationId) {
      this.$router.push({ name: 'StaffReportGeneration', params: { applicationId: applicationId } })
    },
    toViewReport(applicationId) {
      const url = `/application-reports/${applicationId}/`
      window.open(url, '_blank')
    },
  },
}
</script>

<style lang="scss" scoped>
.tag {
  margin: 0 10px;
}

.fixed-width {
  word-wrap: break-word;
  width: 180px;
}

.table {
  button {
    width: 9rem;
  }
}

.orgSub {
  max-width: 110px;
}

.evals {
  min-width: 280px;
}

.is-success > .child-of-application-link {
  color: white;
}
</style>
